/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';


export default class extends Logic
{
  constructor (zone, parent)
  {
    super(zone);

    this.parent = parent;

    this.hex = zone.getAbsoluteHex();
  }


  getNeighbor (index)
  {
    const hex = this.hex.getNeighborsInOrder()[index];

    return this.parent.getZone(hex);
  }


  getNeighbors ()
  {
    return this.hex.getNeighborsInOrder().map(hex => this.parent.getZone(hex));
  }


  isExternalBorder (neighbor)
  {
    return neighbor == null;
  }


  isTemporaryBorder (neighbor)
  {
    return false;
  }


  isGroupBorder (neighbor)
  {
    return neighbor != null && neighbor.cass.sector !== this.cass.sector;
  }


  isJaggedBorder (neighbor)
  {
    return false;
  }



  isEmphasized ()
  {
    return false;
  }


  isDimmed ()
  {
    return false;
  }


  getBeaconValue ()
  {
    return 0;
  }


  isEstablished ()
  {
    return false;
  }


  getBackgroundBand ()
  {
    return this.parent.getValueBand(this.cass.value);
  }


  getDisplayHex ()
  {
    return this.hex;
  }


  getEntityHex ()
  {
    return this.hex;
  }


  getColor ()
  {
    return null;
  }


  equals (other)
  {
    return super.equals(other) && this.parent.equals(other.parent);
  }


};
